import Macy from '$c3local/lib/macy.min.js';

export function initReviews() {
    for (const container of document.querySelectorAll('.reviews')) {
        new Macy({
            container: container,
            columns: 4,
            margin: 32,
            breakAt: {
                990: {
                    margin: 16,
                    columns: 3,
                },
                768: {
                    margin: 16,
                    columns: 2,
                },
                600: {
                    margin: 8,
                    columns: 1,
                },
            },
        });

        container.classList.add('reviews--initialized');

        for (const review of container.querySelectorAll('.review')) {
            const readMore = review.querySelector('.review-read-more');
            if (readMore === null) {
                continue;
            }

            const button = readMore.querySelector('button');
            const dialog = readMore.querySelector('dialog');
            button.addEventListener('click', () => dialog.showModal());
        }
    }
}
